import * as React from 'react'
import styled from 'styled-components'

const google = require('src/assets/configurator/google_reviews.png')
const seal = require('src/assets/wizard/funeralHomeCertificate.png')
const myclimate = require('src/assets/wizard/myclimate_badge.png')

const Container = styled.div`
  padding: 30px;
  background-color: #fff;

  .group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-end;
    max-width: 1200px;
    margin: auto;
    margin-bottom: 30px;
  }

  .supporter {
    max-width: 200px;
    .title {
      font-weight: bold;
      text-align: center;
      line-height: 1.3;
    }
    .check {
      text-align: center;
      i {
        margin-right: 7.5px;
      }
      p {
        display: inline;
        font-size: 12px;
      }
    }
  }

  img {
    display: block;
    margin: 15px auto;
  }
`

export const Support = () => (
  <Container>
    <div className='group'>
      <div className='supporter'>
        <img src={seal} alt='Staatlich geprüfter Bestatter' width={100} />
        <p className='title'>Staatlich geprüfter Bestatter</p>
        <div className='check'>
          <i className='fas fa-check' />
          <p>Geprüfte Qualität</p>
        </div>
        <div className='check'>
          <i className='fas fa-check' />
          <p>Fort- und Weiterbildung</p>
        </div>
      </div>
      <div className='supporter'>
        <img src='https://res.cloudinary.com/dkyl4jbxx/image/upload/w_74,h_74,c_fill,f_auto/v1630548049/zerti_gold_new.png' alt='Trusted Shops' />
        <p className='title'>Ausgezeichnet mit eKomi Gütesiegel in Gold</p>
        <div className='check'>
          <i className='fas fa-check' />
          <p>Geprüfte Prozesse</p>
        </div>
        <div className='check'>
          <i className='fas fa-check' />
          <p>Gesicherte Qualität</p>
        </div>
      </div>
      <div className='supporter'>
        <img src={myclimate} alt='My Climate' width={140} />
        <p className='title'>Zertifiziert durch MyClimate</p>
        <div className='check'>
          <i className='fas fa-check' />
          <p>Klimaneutral</p>
        </div>
        <div className='check'>
          <i className='fas fa-check' />
          <p>Umweltbewusst</p>
        </div>
      </div>
      <div className='supporter'>
        <img src={google} alt='Google Reviews' width={120} />
        <p className='title'>Höchste Kundenzufriedenheit</p>
        <div className='check'>
          <i className='fas fa-check' />
          <p>99.7% Zufriedenheit</p>
        </div>
        <div className='check'>
          <i className='fas fa-check' />
          <p>1.500+ Familien betreut</p>
        </div>
      </div>
    </div>
  </Container>
)

export default Support



// WEBPACK FOOTER //
// ./src/components/layout/Support.tsx